import React from 'react';

import { SegmentedControl } from '@reckon-web/segmented-control';

export type KanbanOrList = 'kanban' | 'list';

const kanbanOrListOptions: { label: string; value: KanbanOrList }[] = [
  { label: 'Kanban', value: 'kanban' },
  { label: 'List', value: 'list' },
];

export const KanbanOrListToggle: React.FC<{
  kanbanOrList: KanbanOrList;
  setKanbanOrList: (kanbanOrList: KanbanOrList) => void;
}> = ({ kanbanOrList, setKanbanOrList }) => (
  <SegmentedControl
    options={kanbanOrListOptions}
    value={kanbanOrList}
    onChange={setKanbanOrList}
    data-testid={`kanban-list-control`}
  />
);
